module.exports = __webpack_public_path__ + "img/check.1e18e62d.svg";